<banner-app
  [Fixtop]="''"
  [retroSelected]="true"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>
<div class="final-page__container">
  <div class="final-page__text-container">
    <p class="final-page__text-title">Debes ponerte en contacto con la Registraduría</p>
    <p class="final-page__text">
      Verifica que tu nombre, documento de identidad y demás datos coincidan con los registros oficiales.
    </p>
  </div>
  <div class="final-page__image-container">
    <img
      src="./assets/img/contactar-registraduria.png"
      class="final-page__image"
      alt="Imagen de no pasa SARLAFT"
      loading="lazy"
    />
  </div>
  <div class="final-page__button-container">
    <button class="final-page__button" (click)="redirect()">Entendido</button>
  </div>
</div>

<app-footer-app class="footer-fixed" />